<template>
  <a-modal
    :title="title"
    :visible="visible"
    :footer="null"
    :maskClosable="false"
    :destroyOnClose="true"
    width="460px"
    @cancel="$emit('close')"
  >
    <a-form-model
      ref="form"
      layout="vertical"
      :model="form"
      :rules="rules"
      autocomplete="off"
      @submit.native.prevent
    >
      <a-form-model-item v-if="mode === 'change'" label="原二级密码" prop="oldPassword">
        <security-password-input v-model="form.oldPassword" placeholder="请输入原二级密码" @pressEnter="submit" />
      </a-form-model-item>
      <a-form-model-item label="新二级密码" prop="newPassword">
        <security-password-input v-model="form.newPassword" placeholder="请输入新二级密码（至少6位）" @pressEnter="submit" />
      </a-form-model-item>
      <a-form-model-item label="确认新二级密码" prop="confirmPassword">
        <security-password-input v-model="form.confirmPassword" placeholder="请再次输入新二级密码" @pressEnter="submit" />
      </a-form-model-item>
      <div class="footer-button">
        <a-button @click="$emit('close')">取消</a-button>
        <a-button type="primary" :loading="loading" @click="submit">提交</a-button>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import SecurityPasswordInput from './PasswordInput.vue'

export default {
  name: 'SalarySecurityManage',
  components: { SecurityPasswordInput },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      mode: 'init',
      form: {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      }
    }
  },
  computed: {
    title () {
      return this.mode === 'change' ? '修改工资查询二级密码' : '设置工资查询二级密码'
    },
    rules () {
      const base = [
        { required: true, message: '请输入新二级密码', trigger: 'blur' },
        { min: 6, message: '密码长度不能少于 6 位', trigger: 'blur' }
      ]
      const confirm = [
        { required: true, message: '请再次输入新二级密码', trigger: 'blur' },
        { validator: (rule, value, callback) => {
          if (value && value !== this.form.newPassword) {
            callback(new Error('两次输入的密码不一致'))
          } else {
            callback()
          }
        },
        trigger: 'blur'
        }
      ]
      const rules = {
        newPassword: base,
        confirmPassword: confirm
      }
      if (this.mode === 'change') {
        rules.oldPassword = [
          { required: true, message: '请输入原二级密码', trigger: 'blur' }
        ]
      }
      return rules
    }
  },
  watch: {
    visible (val) {
      if (val) this.initForm()
    }
  },
  mounted () {
    if (this.visible) this.initForm()
  },
  methods: {
    initForm () {
      this.form = {
        oldPassword: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      }
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
      this.$get('/salary/security/status').then((r) => {
        const data = r.data && r.data.data
        this.mode = (data && data.hasPassword) ? 'change' : 'init'
      }).catch(() => {
        this.mode = 'init'
      })
    },
    submit () {
      this.$refs.form.validate((valid) => {
        if (!valid) return false
        this.loading = true
        if (this.mode === 'init') {
          this.$postJson('/salary/security/init', {
            password: this.form.newPassword,
            confirmPassword: this.form.confirmPassword
          }).then((r) => {
            this.loading = false
            if (r.data && r.data.status === 1) {
              this.$message.success((r.data && r.data.message) || '设置成功')
              this.$emit('success')
            } else {
              this.$message.error((r.data && r.data.message) || '设置失败')
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
          this.$postJson('/salary/security/change', {
            oldPassword: this.form.oldPassword,
            newPassword: this.form.newPassword,
            confirmPassword: this.form.confirmPassword
          }).then((r) => {
            this.loading = false
            if (r.data && r.data.status === 1) {
              this.$message.success((r.data && r.data.message) || '修改成功')
              this.$emit('success')
            } else {
              this.$message.error((r.data && r.data.message) || '修改失败')
            }
          }).catch(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/salary/security/index.vue